export default __webpack_public_path__ + "static/mobilepartners-e1f568994034b446d1d524fe466afe66.png";